<template>
  <v-container fluid>
    <v-layout row wrap>
      <v-flex class="d-flex justify-space-between mb-3 align-center" xs12>
        <h3 class="font-weight-bold">Service Providers Reports</h3>
        <div class="text-xs-right">
          <export-button
              class="ml-2"
              v-if="$oauth.checkIfHasPermission(['export service-provider'])"/>
          <refresh-button :click-function="getAll"></refresh-button>
        </div>
      </v-flex>
      <v-flex xs12>
        <v-card>
          <v-layout class="py-1 mx-2" row wrap>
            <v-flex sm6 class="pb-0">
              <v-select
                  :items="service_providers"
                  item-value="id"
                  item-text="name"
                  flat
                  hide-details
                  label="Filter By Service Provider"
                  @change="handleFilterChange"
                  prepend-inner-icon="filter_list"
                  solo
                  clearable
                  v-model="filters.service_providers"
              />
            </v-flex>

          </v-layout>
          <v-divider></v-divider>
          <v-card-text class="pa-0">
            <v-data-table
                :footer-props="footerProps"
                :headers="headers"
                :items="travellersList"
                :loading="loading"
                :options.sync="pagination"
                :server-items-length="totalNumber"
                item-key="id">
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import FileInput from "../components/FileInput";
import {commonListMixin} from "../mixins/commonListMixin";
import FormErrorDisplayHandler from "../components/FormErrorDisplayHandler";
import {validationMixin} from "../mixins/validationMixin";
import RefreshButton from "@/components/RefreshButton";
import FileDisplay from "../components/FileDisplay";
import TableStatus from "@/components/TableStatus";
import {mapGetters} from "vuex";


export default {
  name: "ServiceProvider",
  components: {FileDisplay, RefreshButton, FormErrorDisplayHandler, FileInput, TableStatus},
  data() {
    return {
      model: "service-provider-reports",
      types: [],
      headers: [
        {
          text: 'S.N.',
          value: 's_no',
          sortable: false
        },
        {
          text: "Name",
          value: "traveller.full_name"
        },
        {
          text: "Address",
          value: "traveller.full_address",
          sortable: false
        },
        {
          text: 'Traveller Contact',
          value: 'traveller.contact_number'
        },
        {
          text: 'Service Provider Name',
          value: 'extra.service_provider_details.provider.name'
        },
        // {
        //   text: "Action",
        //   value: "action",
        //   sortable: false
        // }
      ],
    };
  },

  mixins: [commonListMixin, validationMixin],

  computed: {
    travellersList() {
      return this.$store.state.CommonList.all;
    },
    ...mapGetters({
      service_providers: "ServiceProvider/service_provider",
    }),
  },
  methods:{
    getServiceProviders() {
      this.$store.dispatch("ServiceProvider/getAllServiceProvider")
    },
  },
  mounted() {
    this.$store.commit("CommonList/setModel", this.model);
    this.getServiceProviders()
  }
}
</script>

<style scoped>

</style>



